export { default } from "./CloseIcon";
